import * as React from "react";
import { useState, useEffect, useRef } from "react";
import cargandoCard from "../../components/cargando-card";
// import sinAccesoCard from "../../components/sin-acceso-card";
import Select from "react-select";
// import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import readXlsxFile from "read-excel-file";
import { Upload, Download, ChevronDown, RotateCcw, Settings } from "lucide-react";
import { ESTILO_BOTON_GENERAL_ACEPTAR, } from "../../utils/const/estilos-const";
import Spinner from "../../components/spinner";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import Calendar from "../../components/calendar";
import SwitchComponent from "../../components/switch";
import { obtenerTodasLasUnidades } from "../../api/gestion-dts/gestion";
import { obtenerFormularioDefault, obtenerListaFormulario } from "../../api/api-formulario";
import moment from "moment";
// import { COLOR_VERDE_MAIN } from "../../utils/const/colors-const";
import { INDEX_COLUMNAS_ASIGNACION, NOMBRE_COLUMNAS_ASIGNACION } from "./const/columnas";
import { sharedExportarLink, sharedNextPage, sharedParseFecha } from "../../utils/shared-functions";
import shortid from "shortid";
import { crearAsignacion, } from "../../api/api-asignacion";
import { obtenerListaConfiguracionAsignacion } from "../../api/api-configuracion-asignacion";
import { ASIGNACION_FROM, VERSION_ASIGNACION } from "./const/version";
import ModalAsignacionOpcionesAvanzadas from "../../components/modal-asignacion-opciones-avanzadas";
import { sharedDistribuirPedidosPorConfiguracion } from "../../utils/shared-distribucion";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../usuarios/gestionar-rol-usuario-web/pages-const";

let $ = window.$;

export default function AsignacionIndex() {
    const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
    const { t } = useTranslation();
    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);

    const [processingVisible, setProcessingVisible] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

    const [requestSend, setRequestSend] = useState(false);

    const [excelValido, setExcelValido] = useState(false);
    const [showImportDropdown, setShowImportDropdown] = useState(false);
    const [isCleaning, setIsCleaning] = useState(false);
    const importDropdownRef = useRef(null);

    const [listaVehiculos, setListaVehiculos] = useState([]);
    const [vehiculoSelected, setVehiculoSelected] = useState(null);
    const [listaFormulario, setListaFormulario] = useState([]);
    const [formularioSelected, setFormularioSelected] = useState(null);

    const [fechaSelected, setFechaSelected] = useState(moment().format("YYYY-MM-DD"));

    const [modalOpcionesAvanzadasAbierto, setModalOpcionesAvanzadasAbierto] = useState(false);
    const [switchOpcionesAvanzadas, setSwitchOpcionesAvanzadas] = useState(false);

    const [configuracionAsignacion, setConfiguracionAsignacion] = useState(null);

    const [rowsData, setRowsData] = useState([]);
    const [btnImportar, setBtnImportar] = useState(false);
    const [btnExportar, setBtnExportar] = useState(false);
    const [btnConfiguracion, setBtnConfiguracion] = useState(false);
    const [btnLimpiar, setBtnLimpiar] = useState(false);
    const [btnAceptar, setBtnAceptar] = useState(false);
    const [btnEliminar, setBtnEliminar] = useState(false);

    const [opcionesAvanzadas, setOpcionesAvanzadas] = useState({});

    useEffect(() => {
        // console.log('DashboardPage useEffect');
        iniciar();
    }, []);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (importDropdownRef.current && !importDropdownRef.current.contains(event.target)) {
                setShowImportDropdown(false);
            }
        };

        if (showImportDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showImportDropdown]);

    const iniciar = async () => {
        let tieneAcceso = false;
        try {
            let objEnviar = {};
            if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
                tieneAcceso = true;
                setBtnImportar(true);
                setBtnExportar(true);
                setBtnConfiguracion(true);
                setBtnLimpiar(true);
                setBtnAceptar(true);
                setBtnEliminar(true);
            }
            if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
                const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
                objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
                const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
                if (response.error === false && response.data !== undefined) {
                    const permisos = JSON.parse(response.data.permisos);
                    // console.log('permisos');
                    // console.log(permisos);
                    if (Array.isArray(permisos) && permisos.length > 0) {
                        const manage = permisos.find(p => p.id === 5);
                        if (manage !== undefined && manage !== null) {
                            const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.ASIGNACION_PRINCIPAL);
                            // console.log('permisosPage');
                            // console.log(permisosPage);
                            tieneAcceso = permisosPage.checked;
                            if (tieneAcceso === false) {
                                return;
                            }
                            // console.log('permisosPage');
                            // console.log(permisosPage);
                            const permisoBtnImportar = permisosPage.acciones.find(a => a.value === 'btn_importar');
                            const permisoBtnExportar = permisosPage.acciones.find(a => a.value === 'btn_exportar');
                            const permisoBtnConfiguracion = permisosPage.acciones.find(a => a.value === 'btn_configuracion');
                            const permisoBtnLimpiar = permisosPage.acciones.find(a => a.value === 'btn_limpiar');
                            const permisoBtnAceptar = permisosPage.acciones.find(a => a.value === 'btn_aceptar');
                            const permisoBtnEliminar = permisosPage.acciones.find(a => a.value === 'btn_eliminar');
                            setBtnImportar(permisoBtnImportar?.checked);
                            setBtnExportar(permisoBtnExportar?.checked);
                            setBtnConfiguracion(permisoBtnConfiguracion?.checked);
                            setBtnLimpiar(permisoBtnLimpiar?.checked);
                            setBtnAceptar(permisoBtnAceptar?.checked);
                            setBtnEliminar(permisoBtnEliminar?.checked);
                        }
                    }
                }
            }
            if (tieneAcceso === true) {
                const configuracionAsignacion = await obtenerListaConfiguracionAsignacion({}, false, t);
                // console.log('configuracionAsignacion');
                // console.log(configuracionAsignacion);
                if (Array.isArray(configuracionAsignacion) === true && configuracionAsignacion.length > 0) {
                    setConfiguracionAsignacion(configuracionAsignacion[0]);
                }

                const unidades = await obtenerTodasLasUnidades();
                // console.log('unidades');
                // console.log(unidades);
                setListaVehiculos(unidades);

                const formularios = await obtenerListaFormulario({}, true, t);
                // console.log('formularios');
                // console.log(formularios);
                setListaFormulario(formularios);

                const formularioDefault = await obtenerFormularioDefault();
                // console.log('formularioDefault');
                // console.log(formularioDefault);
                setFormularioSelected(formularioDefault);

                setRowsData([]);
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        } finally {
            setCargandoPage(false);
            setTieneAccesoAlModulo(tieneAcceso);
        }
    };

    useEffect(() => {
        // Small delay to ensure DOM is ready
        const timer = setTimeout(() => {
            const gridElement = $("#gridContainer");
            if (gridElement.length) {
                try {
                    const gridInstance = gridElement.dxDataGrid("instance");
                    if (gridInstance) {
                        // Grid already exists, just update the data source
                        gridInstance.option("dataSource", rowsData);
                    } else {
                        // Grid doesn't exist yet, initialize it
                        inicializarGrid();
                    }
                } catch (e) {
                    // Grid doesn't exist yet, initialize it
                    inicializarGrid();
                }
            }
        }, 100);

        return () => clearTimeout(timer);
    }, [rowsData]);

    const inicializarGrid = () => {
        try {
            const gridElement = $("#gridContainer");

            // Check if element exists
            if (!gridElement.length) {
                // console.warn("Grid container element not found");
                return;
            }

            // Initialize the grid
            gridElement.dxDataGrid({
                dataSource: rowsData,
                paging: {
                    pageSize: 20,
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [50, 100, 150, 200],
                },
                remoteOperations: false,
                groupPanel: { visible: true },
                grouping: {
                    autoExpandAll: false,
                },
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                showBorders: true,
                columnAutoWidth: true,
                filterRow: {
                    visible: true,
                    applyFilter: "auto",
                },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: t("grilla_placeholderbuscar"),
                },
                export: {
                    enabled: true,
                },
                headerFilter: {
                    visible: true,
                },
                columns: [
                    {
                        dataField: "acciones",
                        caption: t("column_acciones"),
                        width: 200,
                        allowFiltering: false,
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            // console.log("cellTemplate acciones");
                            // console.log('options', options);
                            // console.log('options.data', options.data);
                            const buttonContainer = $("<div>").addClass("flex gap-2");
                            if (btnEliminar === true) {
                                // Edit button
                                $("<button>")
                                    .addClass(
                                        "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                                    )
                                    .text(t("column_eliminar"))
                                    .on("click", function () {
                                        eliminarElementoSelected(options.data);
                                    })
                                    .appendTo(buttonContainer);
                            }
                            buttonContainer.appendTo(container);
                        },
                    },
                    {
                        dataField: "placa",
                        caption: t("column_vehiculo"),
                        visible: true,
                        width: 350,
                        dataType: "string",
                    },
                    {
                        dataField: "numeroDocumento",
                        caption: t("column_numero_documento"),
                        visible: true,
                        width: 350,
                        dataType: "string",
                    },
                    {
                        dataField: "codigoCliente",
                        caption: t("column_codigo_cliente"),
                        visible: true,
                        width: 200,
                        dataType: "string",
                    },
                    {
                        dataField: "nombreCliente",
                        caption: t("column_nombre_cliente"),
                        visible: true,
                        width: 400,
                        dataType: "string",
                    },
                    {
                        dataField: "latitudCliente",
                        caption: t("column_latitud_cliente"),
                        width: 200,
                    },
                    {
                        dataField: "longitudCliente",
                        caption: t("column_longitud_cliente"),
                        width: 200,
                    },
                    {
                        dataField: "direccionCliente",
                        caption: t("column_direccion_cliente"),
                        width: 200,
                    },
                    {
                        dataField: "telefonoCliente",
                        caption: t("column_telefono_cliente"),
                        width: 200,
                    },
                    {
                        dataField: "fechaFactura",
                        caption: t("column_fecha_factura"),
                        width: 300,
                        dataType: "string",
                    },
                    {
                        dataField: "numeroFactura",
                        caption: t("column_numero_factura"),
                        width: 200,
                    },
                    {
                        dataField: "valorFactura",
                        caption: t("column_valor_factura"),
                        width: 200,
                    },
                    {
                        dataField: "codigoAlmacen",
                        caption: t("column_codigo_almacen"),
                        width: 200,
                    },
                    {
                        dataField: "nombreAlmacen",
                        caption: t("column_nombre_almacen"),
                        width: 200,
                    },
                    {
                        dataField: "latitudAlmacen",
                        caption: t("column_latitud_almacen"),
                        width: 200,
                    },
                    {
                        dataField: "longitudAlmacen",
                        caption: t("column_longitud_almacen"),
                        width: 200,
                    },
                    {
                        dataField: "codigoProducto",
                        caption: t("column_codigo_producto"),
                        width: 200,
                    },
                    {
                        dataField: "nombreProducto",
                        caption: t("column_nombre_producto"),
                        width: 200,
                    },
                    {
                        dataField: "unidadMedida",
                        caption: t("column_unidad_medida"),
                        width: 200,
                    },
                    {
                        dataField: "cantidad",
                        caption: t("column_cantidad"),
                    },
                    {
                        dataField: "peso",
                        caption: t("column_peso"),
                        width: 200,
                    },
                    {
                        dataField: "volumen",
                        caption: t("column_volumen"),
                        width: 200,
                    },
                    {
                        dataField: "monto",
                        caption: t("column_monto"),
                        width: 200,
                    },
                    {
                        dataField: "moneda",
                        caption: t("column_moneda"),
                        width: 200,
                    },
                    {
                        dataField: "codigoVendedor",
                        caption: t("column_codigo_vendedor"),
                        width: 200,
                    },
                    {
                        dataField: "nombreVendedor",
                        caption: t("column_nombre_vendedor"),
                        width: 200,
                    },
                    {
                        dataField: "region",
                        caption: t("column_region"),
                        width: 200,
                    },
                    {
                        dataField: "fechaEntrega",
                        caption: t("column_fecha_entrega"),
                        width: 300,
                        dataType: "string",
                    },
                    {
                        dataField: "numeroEmbarque",
                        caption: t("column_numero_embarque"),
                        width: 200,
                    },
                    {
                        dataField: "tipoServicio",
                        caption: t("column_tipo_servicio"),
                        width: 200,
                    },
                    {
                        dataField: "estadoPago",
                        caption: t("column_estado_pago"),
                        width: 200,
                    },
                    {
                        dataField: "telefonosNotificacion",
                        caption: t("column_telefonos_notificacion"),
                        width: 200,
                    },
                    {
                        dataField: "correosNotificacion",
                        caption: t("column_correos_notificacion"),
                        width: 200,
                    },
                    {
                        dataField: "prefijo",
                        caption: t("column_prefijo"),
                    },
                    {
                        dataField: "observaciones",
                        caption: t("column_observaciones"),
                        width: 200,
                    },
                    {
                        dataField: "fechaProgramacionSalida",
                        caption: t("column_fecha_programacion_salida"),
                        width: 300,
                        dataType: "string",
                    },
                    {
                        dataField: "fechaCarguio",
                        caption: t("column_fecha_carguio"),
                        width: 300,
                        dataType: "string",
                    },
                ],
            });
        } catch (err) {
            console.error("Error initializing grid:", err);
        }
    };

    const eliminarElementoSelected = (elemento) => {
        // console.log('eliminarElementoSelected');
        // console.log(elemento);
        setRowsData(rowsData.filter(item => item.numeroDocumento !== elemento.numeroDocumento));
    };

    const handleFileChangeGeneral = async (event) => {
        try {
            if (vehiculoSelected === null) {
                alert(t("alert_debe_seleccionar_vehiculo"));
                return;
            }
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            // console.log('file');
            // console.log(file);

            // Check if file is xlsx
            if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                console.error('El archivo debe ser un archivo Excel (.xlsx o .xls)');
                alert(t("alert_archivo_invalido") + " only (.xlsx o .xls)");
                // setExcelValido(false);
                return;
            }
            let rows = await readXlsxFile(file);
            if (Array.isArray(rows) === false) {
                alert(t("alert_archivo_invalido"));
                // setExcelValido(false);
                return;
            }
            if (rows.length === 0) {
                alert(t("alert_archivo_vacio"));
                // setExcelValido(false);
                return;
            }
            // console.log('rows');
            // console.log(rows);
            // setExcelValido(true);
            rows.shift();
            if (rows.length === 0) {
                alert(t("alert_archivo_vacio"));
                // setExcelValido(false);
                return;
            }
            // console.log('rows');
            // console.log(rows);
            let rowsData = [];
            for (let i = 0; i < rows.length; i++) {
                let fechaFactura = rows[i][INDEX_COLUMNAS_ASIGNACION.FECHA_FACTURA];
                fechaFactura = sharedParseFecha(fechaFactura);
                // console.log('fechaFactura');
                // console.log(fechaFactura);
                let fechaEntrega = rows[i][INDEX_COLUMNAS_ASIGNACION.FECHA_ENTREGA];
                fechaEntrega = sharedParseFecha(fechaEntrega);
                // console.log('fechaEntrega');
                // console.log(fechaEntrega);
                let numeroDocumento = rows[i][INDEX_COLUMNAS_ASIGNACION.NUMERO_DOCUMENTO];
                if (numeroDocumento === null ||
                    numeroDocumento === undefined ||
                    numeroDocumento === 0 ||
                    String(numeroDocumento).trim() === '') {
                    numeroDocumento = shortid.generate();
                }
                let obj = {};
                if (switchOpcionesAvanzadas === false) {
                    obj.placa = vehiculoSelected.value;
                }
                let fechaProgramacionSalida = null;
                try {
                    fechaProgramacionSalida = rows[i][INDEX_COLUMNAS_ASIGNACION.FECHA_PROGRAMACION_SALIDA];
                    fechaProgramacionSalida = sharedParseFecha(fechaProgramacionSalida);
                } catch (error) {
                    console.error('Error parsing fecha programacion salida:', error);
                }

                let fechaCarguio = null;
                try {
                    fechaCarguio = rows[i][INDEX_COLUMNAS_ASIGNACION.FECHA_CARGUIO];
                    fechaCarguio = sharedParseFecha(fechaCarguio);
                } catch (error) {
                    console.error('Error parsing fecha carguio:', error);
                }
                // console.log('fechaProgramacionSalida');
                // console.log(fechaProgramacionSalida);
                // console.log('fechaCarguio');
                // console.log(fechaCarguio);

                obj.numeroDocumento = numeroDocumento;
                obj.codigoCliente = rows[i][INDEX_COLUMNAS_ASIGNACION.CODIGO_CLIENTE];
                obj.nombreCliente = rows[i][INDEX_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE];
                // console.log('obj');
                // console.log(obj);
                obj.latitudCliente = rows[i][INDEX_COLUMNAS_ASIGNACION.LATITUD_CLIENTE];
                obj.longitudCliente = rows[i][INDEX_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE];
                // console.log('obj');
                // console.log(obj);
                obj.direccionCliente = rows[i][INDEX_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE];
                obj.telefonoCliente = rows[i][INDEX_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE];
                obj.fechaFactura = fechaFactura;
                obj.numeroFactura = rows[i][INDEX_COLUMNAS_ASIGNACION.NUMERO_FACTURA];
                // console.log('obj');
                // console.log(obj);
                obj.valorFactura = rows[i][INDEX_COLUMNAS_ASIGNACION.VALOR_FACTURA];
                obj.codigoAlmacen = rows[i][INDEX_COLUMNAS_ASIGNACION.CODIGO_ALMACEN];
                obj.nombreAlmacen = rows[i][INDEX_COLUMNAS_ASIGNACION.NOMBRE_ALMACEN];
                obj.latitudAlmacen = rows[i][INDEX_COLUMNAS_ASIGNACION.LATITUD_ALMACEN];
                obj.longitudAlmacen = rows[i][INDEX_COLUMNAS_ASIGNACION.LONGITUD_ALMACEN];
                // console.log('obj');
                // console.log(obj);
                obj.codigoProducto = rows[i][INDEX_COLUMNAS_ASIGNACION.CODIGO_PRODUCTO];
                obj.nombreProducto = rows[i][INDEX_COLUMNAS_ASIGNACION.NOMBRE_PRODUCTO];
                obj.unidadMedida = rows[i][INDEX_COLUMNAS_ASIGNACION.UNIDAD_MEDIDA];
                obj.cantidad = rows[i][INDEX_COLUMNAS_ASIGNACION.CANTIDAD];
                obj.peso = rows[i][INDEX_COLUMNAS_ASIGNACION.PESO];
                obj.volumen = rows[i][INDEX_COLUMNAS_ASIGNACION.VOLUMEN];
                // console.log('obj');
                // console.log(obj);
                obj.monto = rows[i][INDEX_COLUMNAS_ASIGNACION.MONTO];
                obj.moneda = rows[i][INDEX_COLUMNAS_ASIGNACION.MONEDA];
                obj.codigoVendedor = rows[i][INDEX_COLUMNAS_ASIGNACION.CODIGO_VENDEDOR];
                obj.nombreVendedor = rows[i][INDEX_COLUMNAS_ASIGNACION.NOMBRE_VENDEDOR];
                obj.region = rows[i][INDEX_COLUMNAS_ASIGNACION.REGION];
                obj.fechaEntrega = fechaEntrega;
                obj.numeroEmbarque = rows[i][INDEX_COLUMNAS_ASIGNACION.NUMERO_EMBARQUE];
                obj.tipoServicio = rows[i][INDEX_COLUMNAS_ASIGNACION.TIPO_SERVICIO];
                obj.estadoPago = rows[i][INDEX_COLUMNAS_ASIGNACION.ESTADO_PAGO];
                obj.telefonosNotificacion = rows[i][INDEX_COLUMNAS_ASIGNACION.TELEFONOS_NOTIFICACION];
                obj.correosNotificacion = rows[i][INDEX_COLUMNAS_ASIGNACION.CORREOS_NOTIFICACION];
                obj.prefijo = rows[i][INDEX_COLUMNAS_ASIGNACION.PREFIJO];
                obj.observaciones = rows[i][INDEX_COLUMNAS_ASIGNACION.OBSERVACIONES];
                // console.log('obj');
                // console.log(obj);
                obj.fechaProgramacionSalida = fechaProgramacionSalida;
                obj.fechaCarguio = fechaCarguio;
                rowsData.push(obj);
            }
            if (switchOpcionesAvanzadas === true) {
                const response = sharedDistribuirPedidosPorConfiguracion(rowsData, opcionesAvanzadas);
                if (response.error === false) {
                    setRowsData(response.data);
                }
                if (response.error === true) {
                    showToast(response.message);
                    setRowsData([]);
                    return;
                }
            }
            if (switchOpcionesAvanzadas === false) {
                setRowsData(rowsData);
            }
        } catch (err) {
            console.error('Error reading Excel file:', err);
        } finally {
            event.target.value = '';
        }
    };

    const handleFileChangePersonalizado = async (event) => {
        try {
            if (vehiculoSelected === null) {
                alert(t("alert_debe_seleccionar_vehiculo"));
                return;
            }
            if (configuracionAsignacion === null) {
                alert(t("alert_no_se_pudo_leer_configuracion"));
                return;
            }
            const file = event.target.files[0];
            if (!file) {
                return;
            }

            // Check if file is xlsx
            if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                console.error('El archivo debe ser un archivo Excel (.xlsx o .xls)');
                setExcelValido(false);
                return;
            }

            // Read the Excel file
            const rows = await readXlsxFile(file);

            // console.log('Excel file content:');
            // console.log(rows);
            // console.log('configuracionAsignacion');
            // console.log(configuracionAsignacion);
            const configuracion = JSON.parse(configuracionAsignacion.configuracion);
            // console.log('configuracion');
            // console.log(configuracion);
            if (Array.isArray(rows) === false) {
                alert(t("alert_archivo_invalido"));
                // setExcelValido(false);
                return;
            }
            if (rows.length === 0) {
                alert(t("alert_archivo_vacio"));
                // setExcelValido(false);
                return;
            }
            // setExcelValido(true);
            rows.shift();
            if (rows.length === 0) {
                alert(t("alert_archivo_vacio"));
                // setExcelValido(false);
                return;
            }
            const INDEX_NUMERO_DOCUMENTO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.NUMERO_DOCUMENTO]?.value;
            const INDEX_CODIGO_CLIENTE = configuracion[NOMBRE_COLUMNAS_ASIGNACION.CODIGO_CLIENTE]?.value;
            const INDEX_NOMBRE_CLIENTE = configuracion[NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE]?.value;
            const INDEX_LATITUD_CLIENTE = configuracion[NOMBRE_COLUMNAS_ASIGNACION.LATITUD_CLIENTE]?.value;
            const INDEX_LONGITUD_CLIENTE = configuracion[NOMBRE_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE]?.value;
            const INDEX_DIRECCION_CLIENTE = configuracion[NOMBRE_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE]?.value;
            const INDEX_TELEFONO_CLIENTE = configuracion[NOMBRE_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE]?.value;
            const INDEX_FECHA_FACTURA = configuracion[NOMBRE_COLUMNAS_ASIGNACION.FECHA_FACTURA]?.value;
            const INDEX_NUMERO_FACTURA = configuracion[NOMBRE_COLUMNAS_ASIGNACION.NUMERO_FACTURA]?.value;
            const INDEX_VALOR_FACTURA = configuracion[NOMBRE_COLUMNAS_ASIGNACION.VALOR_FACTURA]?.value;
            const INDEX_CODIGO_ALMACEN = configuracion[NOMBRE_COLUMNAS_ASIGNACION.CODIGO_ALMACEN]?.value;
            const INDEX_NOMBRE_ALMACEN = configuracion[NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_ALMACEN]?.value;
            const INDEX_LATITUD_ALMACEN = configuracion[NOMBRE_COLUMNAS_ASIGNACION.LATITUD_ALMACEN]?.value;
            const INDEX_LONGITUD_ALMACEN = configuracion[NOMBRE_COLUMNAS_ASIGNACION.LONGITUD_ALMACEN]?.value;
            const INDEX_CODIGO_PRODUCTO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.CODIGO_PRODUCTO]?.value;
            const INDEX_NOMBRE_PRODUCTO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_PRODUCTO]?.value;
            const INDEX_UNIDAD_MEDIDA = configuracion[NOMBRE_COLUMNAS_ASIGNACION.UNIDAD_MEDIDA]?.value;
            const INDEX_CANTIDAD = configuracion[NOMBRE_COLUMNAS_ASIGNACION.CANTIDAD]?.value;
            const INDEX_PESO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.PESO]?.value;
            const INDEX_VOLUMEN = configuracion[NOMBRE_COLUMNAS_ASIGNACION.VOLUMEN]?.value;
            const INDEX_MONTO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.MONTO]?.value;
            const INDEX_MONEDA = configuracion[NOMBRE_COLUMNAS_ASIGNACION.MONEDA]?.value;
            const INDEX_CODIGO_VENDEDOR = configuracion[NOMBRE_COLUMNAS_ASIGNACION.CODIGO_VENDEDOR]?.value;
            const INDEX_NOMBRE_VENDEDOR = configuracion[NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_VENDEDOR]?.value;
            const INDEX_REGION = configuracion[NOMBRE_COLUMNAS_ASIGNACION.REGION]?.value;
            const INDEX_FECHA_ENTREGA = configuracion[NOMBRE_COLUMNAS_ASIGNACION.FECHA_ENTREGA]?.value;
            const INDEX_NUMERO_EMBARQUE = configuracion[NOMBRE_COLUMNAS_ASIGNACION.NUMERO_EMBARQUE]?.value;
            const INDEX_TIPO_SERVICIO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.TIPO_SERVICIO]?.value;
            const INDEX_ESTADO_PAGO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.ESTADO_PAGO]?.value;
            const INDEX_TELEFONOS_NOTIFICACION = configuracion[NOMBRE_COLUMNAS_ASIGNACION.TELEFONOS_NOTIFICACION]?.value;
            const INDEX_CORREOS_NOTIFICACION = configuracion[NOMBRE_COLUMNAS_ASIGNACION.CORREOS_NOTIFICACION]?.value;
            const INDEX_PREFIJO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.PREFIJO]?.value;
            const INDEX_OBSERVACIONES = configuracion[NOMBRE_COLUMNAS_ASIGNACION.OBSERVACIONES]?.value;
            let INDEX_FECHA_PROGRAMACION_SALIDA = undefined;
            try {
                INDEX_FECHA_PROGRAMACION_SALIDA = configuracion[NOMBRE_COLUMNAS_ASIGNACION.FECHA_PROGRAMACION_SALIDA]?.value;
            } catch (error) {
                console.error('Error parsing fecha programacion salida:', error);
            }
            let INDEX_FECHA_CARGUIO = undefined;
            try {
                INDEX_FECHA_CARGUIO = configuracion[NOMBRE_COLUMNAS_ASIGNACION.FECHA_CARGUIO]?.value;
            } catch (error) {
                console.error('Error parsing fecha carguio:', error);
            }

            let rowsData = [];
            for (let i = 0; i < rows.length; i++) {
                let fechaFactura = null;
                if (rows[i][INDEX_FECHA_FACTURA] !== undefined) {
                    fechaFactura = rows[i][INDEX_FECHA_FACTURA];
                    fechaFactura = sharedParseFecha(fechaFactura);
                }
                let fechaEntrega = null;
                if (INDEX_FECHA_ENTREGA !== undefined) {
                    fechaEntrega = rows[i][INDEX_FECHA_ENTREGA];
                    fechaEntrega = sharedParseFecha(fechaEntrega);
                }
                let numeroDocumento = rows[i][INDEX_NUMERO_DOCUMENTO];
                if (numeroDocumento === null ||
                    numeroDocumento === undefined ||
                    numeroDocumento === 0 ||
                    String(numeroDocumento).trim() === '') {
                    numeroDocumento = shortid.generate();
                }
                let obj = {};
                if (switchOpcionesAvanzadas === false) {
                    obj.placa = vehiculoSelected.value;
                }
                obj.numeroDocumento = numeroDocumento;
                obj.codigoCliente = rows[i][INDEX_CODIGO_CLIENTE];
                obj.nombreCliente = "";
                if (INDEX_NOMBRE_CLIENTE !== undefined) {
                    obj.nombreCliente = rows[i][INDEX_NOMBRE_CLIENTE];
                }
                obj.latitudCliente = null;
                if (INDEX_LATITUD_CLIENTE !== undefined) {
                    obj.latitudCliente = rows[i][INDEX_LATITUD_CLIENTE];
                }
                obj.longitudCliente = null;
                if (INDEX_LONGITUD_CLIENTE !== undefined) {
                    obj.longitudCliente = rows[i][INDEX_LONGITUD_CLIENTE];
                }
                obj.direccionCliente = "";
                if (INDEX_DIRECCION_CLIENTE !== undefined) {
                    obj.direccionCliente = rows[i][INDEX_DIRECCION_CLIENTE];
                }
                obj.telefonoCliente = "";
                if (INDEX_TELEFONO_CLIENTE !== undefined) {
                    obj.telefonoCliente = rows[i][INDEX_TELEFONO_CLIENTE];
                }
                obj.fechaFactura = fechaFactura;
                obj.numeroFactura = "";
                if (INDEX_NUMERO_FACTURA !== undefined) {
                    obj.numeroFactura = rows[i][INDEX_NUMERO_FACTURA];
                }
                obj.valorFactura = "";
                if (INDEX_VALOR_FACTURA !== undefined) {
                    obj.valorFactura = rows[i][INDEX_VALOR_FACTURA];
                }
                obj.codigoAlmacen = "";
                if (INDEX_CODIGO_ALMACEN !== undefined) {
                    obj.codigoAlmacen = rows[i][INDEX_CODIGO_ALMACEN];
                }
                obj.nombreAlmacen = "";
                if (INDEX_NOMBRE_ALMACEN !== undefined) {
                    obj.nombreAlmacen = rows[i][INDEX_NOMBRE_ALMACEN];
                }
                obj.latitudAlmacen = null;
                if (INDEX_LATITUD_ALMACEN !== undefined) {
                    obj.latitudAlmacen = rows[i][INDEX_LATITUD_ALMACEN];
                }
                obj.longitudAlmacen = null;
                if (INDEX_LONGITUD_ALMACEN !== undefined) {
                    obj.longitudAlmacen = rows[i][INDEX_LONGITUD_ALMACEN];
                }
                obj.codigoProducto = "";
                if (INDEX_CODIGO_PRODUCTO !== undefined) {
                    obj.codigoProducto = rows[i][INDEX_CODIGO_PRODUCTO];
                }
                obj.nombreProducto = "";
                if (INDEX_NOMBRE_PRODUCTO !== undefined) {
                    obj.nombreProducto = rows[i][INDEX_NOMBRE_PRODUCTO];
                }
                obj.unidadMedida = "";
                if (INDEX_UNIDAD_MEDIDA !== undefined) {
                    obj.unidadMedida = rows[i][INDEX_UNIDAD_MEDIDA];
                }
                obj.cantidad = "";
                if (INDEX_CANTIDAD !== undefined) {
                    obj.cantidad = rows[i][INDEX_CANTIDAD];
                }
                obj.peso = "";
                if (INDEX_PESO !== undefined) {
                    obj.peso = rows[i][INDEX_PESO];
                }
                obj.volumen = "";
                if (INDEX_VOLUMEN !== undefined) {
                    obj.volumen = rows[i][INDEX_VOLUMEN];
                }
                obj.monto = "";
                if (INDEX_MONTO !== undefined) {
                    obj.monto = rows[i][INDEX_MONTO];
                }
                obj.moneda = "";
                if (INDEX_MONEDA !== undefined) {
                    obj.moneda = rows[i][INDEX_MONEDA];
                }
                obj.codigoVendedor = "";
                if (INDEX_CODIGO_VENDEDOR !== undefined) {
                    obj.codigoVendedor = rows[i][INDEX_CODIGO_VENDEDOR];
                }
                obj.nombreVendedor = "";
                if (INDEX_NOMBRE_VENDEDOR !== undefined) {
                    obj.nombreVendedor = rows[i][INDEX_NOMBRE_VENDEDOR];
                }
                obj.region = "";
                if (INDEX_REGION !== undefined) {
                    obj.region = rows[i][INDEX_REGION];
                }
                obj.fechaEntrega = fechaEntrega;
                obj.numeroEmbarque = "";
                if (INDEX_NUMERO_EMBARQUE !== undefined) {
                    obj.numeroEmbarque = rows[i][INDEX_NUMERO_EMBARQUE];
                }
                obj.tipoServicio = "";
                if (INDEX_TIPO_SERVICIO !== undefined) {
                    obj.tipoServicio = rows[i][INDEX_TIPO_SERVICIO];
                }
                obj.estadoPago = "";
                if (INDEX_ESTADO_PAGO !== undefined) {
                    obj.estadoPago = rows[i][INDEX_ESTADO_PAGO];
                }
                obj.telefonosNotificacion = "";
                if (INDEX_TELEFONOS_NOTIFICACION !== undefined) {
                    obj.telefonosNotificacion = rows[i][INDEX_TELEFONOS_NOTIFICACION];
                }
                obj.correosNotificacion = "";
                if (INDEX_CORREOS_NOTIFICACION !== undefined) {
                    obj.correosNotificacion = rows[i][INDEX_CORREOS_NOTIFICACION];
                }
                obj.prefijo = "";
                if (INDEX_PREFIJO !== undefined) {
                    obj.prefijo = rows[i][INDEX_PREFIJO];
                }
                obj.observaciones = "";
                if (INDEX_OBSERVACIONES !== undefined) {
                    obj.observaciones = rows[i][INDEX_OBSERVACIONES];
                }
                obj.fechaProgramacionSalida = null;
                try {
                    if (INDEX_FECHA_PROGRAMACION_SALIDA !== undefined) {
                        obj.fechaProgramacionSalida = rows[i][INDEX_FECHA_PROGRAMACION_SALIDA];
                        obj.fechaProgramacionSalida = sharedParseFecha(obj.fechaProgramacionSalida);
                    }
                } catch (error) {
                    console.error('Error parsing fecha programacion salida:', error);
                }
                obj.fechaCarguio = null;
                try {
                    if (INDEX_FECHA_CARGUIO !== undefined) {
                        obj.fechaCarguio = rows[i][INDEX_FECHA_CARGUIO];
                        obj.fechaCarguio = sharedParseFecha(obj.fechaCarguio);
                    }
                } catch (error) {
                    console.error('Error parsing fecha carguio:', error);
                }
                rowsData.push(obj);
            }
            // console.log('rowsData');
            // console.log(rowsData);
            if (switchOpcionesAvanzadas === true) {
                const response = sharedDistribuirPedidosPorConfiguracion(rowsData, opcionesAvanzadas);
                if (response.error === false) {
                    setRowsData(response.data);
                }
                if (response.error === true) {
                    showToast(response.message);
                    setRowsData([]);
                    return;
                }
            }
            if (switchOpcionesAvanzadas === false) {
                setRowsData(rowsData);
            }
        } catch (err) {
            console.error('Error reading Excel file:', err);
        } finally {
            event.target.value = '';
        }
    };

    const showToast = (message, type = "warning", durationMs = 3000, callback = null) => {
        setToastMessage(message);
        setToastType(type);
        setToastVisible(true);
        // Auto-hide
        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            setToastVisible(false);
            if (callback !== null) {
                callback();
            }
        }, durationMs);
    };

    const toggleImportDropdown = () => {
        setShowImportDropdown(!showImportDropdown);
    };

    const handleImportExcelGeneral = () => {
        setShowImportDropdown(false);
        const input = document.getElementById('importar_asignacion');
        input.click();
    };

    const handleImportExcelPersonalizado = () => {
        setShowImportDropdown(false);
        const input = document.getElementById('importar_personalizado');
        input.click();
    };

    const onClickExportar = () => {
        try {
            let link = "https://gestion.boltrack.net/assets/crearEntregasGenerico.xlsx";
            sharedExportarLink(link, "crearEntregasGenerico.xlsx");
        } catch (err) {
            console.log('onClickExportar err');
            console.log(err);
        }
    };

    const handleSaveClick = async () => {
        try {
            // console.log('handleSaveClick');
            // console.log(rowsData);
            if (Array.isArray(rowsData) === false) {
                showToast(t("alert_archivo_invalido"));
                return;
            }
            if (rowsData.length === 0) {
                showToast(t("alert_archivo_vacio"));
                return;
            }
            if (rowsData.length > 500) {
                showToast(t("alert_maximo_500_elementos"));
                return;
            }
            if (vehiculoSelected === null) {
                showToast(t("alert_debe_seleccionar_vehiculo"));
                return;
            }
            if (fechaSelected === null) {
                showToast(t("alert_debe_seleccionar_fecha"));
                return;
            }
            if (moment(fechaSelected).isValid() === false) {
                showToast(t("alert_fecha_invalida"));
                return;
            }
            if (formularioSelected === null) {
                showToast(t("alert_debe_seleccionar_formulario"));
                return;
            }
            setProcessingVisible(true);
            setRequestSend(true);
            const objEnviar = {
                rowsData,
                valuePlaca: vehiculoSelected.value,
                labelPlaca: vehiculoSelected.label,
                fechaEntrega: fechaSelected,
                idFormulario: formularioSelected.value,
                version: VERSION_ASIGNACION,
                from: ASIGNACION_FROM.EXCEL,
            };
            // console.log('objEnviar');
            // console.log(objEnviar);
            // return;
            const response = await crearAsignacion(objEnviar);
            if (response.error === false) {
                showToast(t("alert_se_creo_correctamente"));
                sharedNextPage("/seguimiento/mapa-seguimiento", {}, history);
            }
            if (response.error === true) {
                alert(response.message);
                showToast(t("alert_no_se_pudo_crear"));
            }
            // }
            // return;
        } catch (err) {
            console.log('handleSaveClick err');
            console.log(err);
        } finally {
            setProcessingVisible(false);
            setRequestSend(false);
        }
    };

    useEffect(() => {
        if (switchOpcionesAvanzadas === true) {
            setVehiculoSelected(null);
        }
    }, [switchOpcionesAvanzadas]);

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            // if (tieneAccesoAlModulo === false) {
            //     return sinAccesoCard();
            // }
            return (
                <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
                    <br />
                    <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
                            <div className="flex items-center gap-2">
                                {/* <ArrowBack onClick={handleCancelClick} /> */}
                                <h2 className="text-xl font-bold text-gray-900">{t("titulo_crear_asignacion")}</h2>
                            </div>
                            <div className="flex items-center gap-3 flex-wrap">
                                <div className="relative" ref={importDropdownRef}>
                                    {btnImportar === true && (
                                        <button className="group relative bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition-all duration-300 transform hover:scale-110 hover:shadow-xl hover:shadow-green-500/50 flex items-center gap-2 overflow-hidden active:scale-95"
                                            onClick={toggleImportDropdown}
                                        >
                                            <span className="relative z-10 flex items-center gap-2">
                                                <Upload className="h-4 w-4 transition-all duration-300 group-hover:-translate-y-1 group-hover:rotate-12 group-hover:scale-110" />
                                                <span className="font-medium transition-all duration-300 group-hover:tracking-wide">{t("label_importar")}</span>
                                                <ChevronDown className={`h-4 w-4 transition-all duration-300 ${showImportDropdown ? 'rotate-180' : ''}`} />
                                            </span>
                                            <span className="absolute inset-0 bg-gradient-to-r from-green-400 via-green-500 to-green-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                            <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
                                            <span className="absolute -inset-1 bg-green-400 opacity-0 group-hover:opacity-20 blur-md transition-opacity duration-300"></span>
                                        </button>
                                    )}
                                    {showImportDropdown && (
                                        <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                                            <div className="py-1" role="menu" aria-orientation="vertical">
                                                <button
                                                    onClick={handleImportExcelGeneral}
                                                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 flex items-center gap-2 transition-colors"
                                                    role="menuitem"
                                                >
                                                    <Upload className="h-4 w-4" />
                                                    {t("label_importar_general")}
                                                </button>
                                                <button
                                                    onClick={handleImportExcelPersonalizado}
                                                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 flex items-center gap-2 transition-colors"
                                                    role="menuitem"
                                                >
                                                    <Upload className="h-4 w-4" />
                                                    {t("label_importar_personalizado")}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {btnExportar === true && (
                                    <button className="group relative bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition-all duration-300 transform hover:scale-110 hover:shadow-xl hover:shadow-blue-500/50 flex items-center gap-2 overflow-hidden active:scale-95"
                                        onClick={onClickExportar}
                                    >
                                        <span className="relative z-10 flex items-center gap-2">
                                            <Download className="h-4 w-4 transition-all duration-300 group-hover:translate-y-1 group-hover:-rotate-12 group-hover:scale-110" />
                                            <span className="font-medium transition-all duration-300 group-hover:tracking-wide">{t("label_exportar")}</span>
                                        </span>
                                        <span className="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                        <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
                                        <span className="absolute -inset-1 bg-blue-400 opacity-0 group-hover:opacity-20 blur-md transition-opacity duration-300"></span>
                                    </button>
                                )}
                            </div>
                        </div>
                        <input
                            type="file"
                            className="hidden"
                            id="importar_asignacion"
                            accept=".xlsx,.xls"
                            onChange={handleFileChangeGeneral}
                        />
                        <input
                            type="file"
                            className="hidden"
                            id="importar_personalizado"
                            accept=".xlsx,.xls"
                            onChange={handleFileChangePersonalizado}
                        />
                        {/* <br /> */}
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                <div className="flex items-center justify-between gap-2">
                                    <label className="block text-sm font-medium text-gray-700 m-0">
                                        {t("label_vehiculo")}
                                    </label>
                                    <div className="flex items-center gap-2">
                                        {btnConfiguracion === true && (
                                            <button
                                                type="button"
                                                className={`p-1.5 transition-colors shrink-0 bg-gray-50`}
                                                aria-pressed={switchOpcionesAvanzadas}
                                                title={t("tooltip_opciones_avanzadas_vehiculo")}
                                                onClick={() => setModalOpcionesAvanzadasAbierto(true)}
                                            >
                                                <Settings className="h-4 w-4" />
                                            </button>
                                        )}
                                        <SwitchComponent
                                            checked={switchOpcionesAvanzadas}
                                            onChange={(checked) => setSwitchOpcionesAvanzadas(checked)}
                                            className="m-0"
                                            trackClassName="h-5 w-9"
                                            thumbClassName={switchOpcionesAvanzadas ? "h-3 w-2.5 translate-x-5" : "h-3 w-2.5 translate-x-0.1"}
                                        />
                                    </div>
                                </div>
                                <Select
                                    options={listaVehiculos}
                                    value={vehiculoSelected}
                                    onChange={(option) => setVehiculoSelected(option)}
                                    placeholder={t("placeholder_seleccione_vehiculo")}
                                    isClearable={true}
                                    isSearchable={true}
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 999 }),
                                        menu: (base) => ({ ...base, zIndex: 999 }),
                                    }}
                                />
                            </div>
                            <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">{t("label_fecha_entrega")}</label>
                                <Calendar
                                    value={fechaSelected}
                                    onChange={(date) => setFechaSelected(date)}
                                    placeholder={t("placeholder_seleccione_fecha")}
                                    id="fecha_asignacion"
                                    name="fecha_asignacion"
                                />
                            </div>
                            <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1.5">{t("label_formulario")}</label>
                                <Select
                                    options={listaFormulario}
                                    value={formularioSelected}
                                    onChange={(option) => setFormularioSelected(option)}
                                    placeholder={t("placeholder_seleccione_formulario")}
                                    isClearable={true}
                                    isSearchable={true}
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 999 }),
                                        menu: (base) => ({ ...base, zIndex: 999 }),
                                    }}
                                />
                            </div>
                        </div>
                        <br />
                        {/* Grid Card */}
                        {btnLimpiar === true && (
                            <div className="flex justify-end">
                                <button
                                    type="button"
                                    className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition-all duration-300 transform hover:scale-110 hover:shadow-xl hover:shadow-green-500/50 flex items-center gap-2 overflow-hidden active:scale-95"
                                    onClick={() => {
                                        setIsCleaning(true);
                                        setRowsData([]);
                                        setExcelValido(false);
                                        // Reset animation after it completes
                                        setTimeout(() => {
                                            setIsCleaning(false);
                                        }, 500);
                                    }}
                                >
                                    <RotateCcw className={`h-4 w-4 transition-transform duration-500 ease-in-out ${isCleaning ? 'rotate-[360deg]' : ''}`} />
                                    {t("label_limpiar")}
                                </button>
                            </div>
                        )}
                        <div className="bg-white border border-gray-200 rounded-lg p-2">
                            <div className="min-h-[400px]">
                                <div
                                    id="gridContainer"
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                    }}
                                />
                            </div>
                        </div>
                        <br />
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                                <div className="flex justify-end">
                                    {btnAceptar === true && requestSend === false && (
                                        <button
                                            type="button"
                                            className={ESTILO_BOTON_GENERAL_ACEPTAR}
                                            onClick={handleSaveClick}
                                        >
                                            {t("label_aceptar")}
                                        </button>
                                    )}
                                    {requestSend === true && (
                                        <button
                                            type="button"
                                            className={ESTILO_BOTON_GENERAL_ACEPTAR}
                                            disabled
                                        >
                                            <div className="flex items-center justify-center gap-2">
                                                <Spinner size="md" color="green" />
                                            </div>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
                    <ToastComponent
                        visible={toastVisible}
                        message={toastMessage}
                        type={toastType}
                        onClose={() => setToastVisible(false)}
                    />
                    <ModalAsignacionOpcionesAvanzadas
                        visible={modalOpcionesAvanzadasAbierto}
                        onClose={() => setModalOpcionesAvanzadasAbierto(false)}
                        opcionesAvanzadas={opcionesAvanzadas}
                        setOpcionesAvanzadas={setOpcionesAvanzadas}
                        showToast={showToast}
                        setProcessingVisible={setProcessingVisible}
                    />
                </div>
            );
        } catch (err) {
            console.log('render err AsignacionIndex');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};
